import { useEffect as r } from "react";
function s(e, n) {
  r(
    () => {
      const t = (o) => {
        !e.current || e.current.contains(o.target) || n(o);
      };
      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    },
    [e, n]
  );
}
export {
  s as default
};
